/**
 * Microsoft Clarity integration (session replay + behavioral analytics).
 *
 * SDK loading: NOT loaded by tazio-fe. Clarity script is injected externally
 *              (typically by GTM tag or the customer portal).
 * Global:      window.clarity
 * Env vars:    none
 *
 * Status: ACTIVE — used opportunistically when the host page loads it.
 *
 * Existing call sites (as of 2026-04-13):
 *   - src/config.js:139-144               identify SSO (token/customer/company/sso)
 *   - src/utilities/commons.js:447        custom_event() forwards (action, label)
 *
 * Clarity API used:
 *   window.clarity("set", key, value)   custom variable
 *   window.clarity("identify", ...)     (NOT currently used by tazio-fe)
 *
 * Naming convention: every public function is prefixed with `clarity_` so
 * the Clarity origin is obvious at every call site, even when imported
 * alongside other integration modules.
 */

export function clarity_is_available() {
  return Boolean(window.clarity)
}

/**
 * Set a custom Clarity variable.
 *   window.clarity("set", key, value)
 *
 * @param {string} key
 * @param {string|number} value
 */
export function clarity_set_variable(key, value) {
  if (!clarity_is_available()) return
  window.clarity('set', key, value)
}

/**
 * Apply the canonical SSO variable mapping currently used in src/config.js.
 *
 * @param {Object} sso - { token, customer, company, email }
 */
export function clarity_set_sso_variables(sso) {
  if (!clarity_is_available()) return
  window.clarity('set', 'token', sso.token)
  window.clarity('set', 'customer', sso.customer)
  window.clarity('set', 'company', sso.company)
  window.clarity('set', 'sso', sso.email)
}
